import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';

export interface XJob {
    id: YId;
    group: XJobGroup;
    code: string;
    key?: string;
    is_enabled: boolean;
    is_running: boolean;
    data: Record<string, string>;
    payload?: any;
    due_at: YTimeString;
    interval?: number;
    preserve_time_of_day: boolean;
    last_status?: number;
    last_elapsed?: number;
    last_taken_at?: YTimeString;
    last_finished_at?: YTimeString;
}

export const x_job_group_values = ['email', 'backend', 'analytics', 'payments', 'accounting', 'triggers', 'video', 'integrations'] as const;
export type XJobGroup = typeof x_job_group_values[number];

export function xJobsGetAll() {
    return $api.GET<XJob[]>('x/jobs');
}

export function xJobCreate(data: any) {
    return $api.POST<XJob>('x/job', data)
}
